import { render, staticRenderFns } from "./dependents.vue?vue&type=template&id=201a49a2&scoped=true&"
import script from "./dependents.vue?vue&type=script&lang=js&"
export * from "./dependents.vue?vue&type=script&lang=js&"
import style0 from "./dependents.vue?vue&type=style&index=0&id=201a49a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a49a2",
  null
  
)

export default component.exports